var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 100 100",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 10,
    x: 17.5,
    y: 45
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 10,
    x: 32.5,
    y: 45
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 10,
    x: 32.5,
    y: 30
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 10,
    x: 17.5,
    y: 30
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 10,
    x: 32.5,
    y: 15
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 10,
    x: 17.5,
    y: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5,20V10H55V5h-2.5h-45H5v5h2.5v85h85V25H95v-5h-2.5H52.5z M47.5,20v70h-35V10h35V20z M87.5,90h-35V25h35V90z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 10,
    x: 57.5,
    y: 45
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 10,
    x: 72.5,
    y: 45
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 10,
    x: 72.5,
    y: 30
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 10,
    x: 57.5,
    y: 30
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 10,
    x: 17.5,
    y: 75
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 10,
    x: 32.5,
    y: 75
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 10,
    x: 32.5,
    y: 60
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 10,
    x: 17.5,
    y: 60
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 10,
    x: 57.5,
    y: 75
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 10,
    x: 72.5,
    y: 75
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 10,
    x: 72.5,
    y: 60
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 10,
    x: 57.5,
    y: 60
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.dd3e7c9fe133a0c55f3b598c3a447461.svg";
export { ForwardRef as ReactComponent };